import { check100QuestionSheets } from "./api/omrApi.js";
import BatchOmrPage from "./BatchOmrPage.js";

export default function Omr100Page() {
  return (
    // <BatchOmrPage
    //   category="OMR 100"
    //   questionCount={100}
    //   endpoint="/api/omr-100/check-batch"
    //   pageDescription="Upload multiple 100-question sheets and check all results on this page."
    // />
    <BatchOmrPage
      questionCount={100}
      title={"100 OMR"}
      description={""}
      submitFunction={check100QuestionSheets}

      image_source = "https://api.networkeducationalacademy.com/wp-content/uploads/2026/09/blank_sheet_100-scaled.jpg"
    />
  );
}
